module.exports = __webpack_public_path__ + "static/media/contact_t0.15a4b290.png";